/**
 * handlers/widget.ts
 * Mini widget polling — fetches widget state every 60 s while drawer is closed.
 */

import { state } from '../state';
import { getWidgetState as apiGetWidgetState } from '../api';
import { updateWidgetState } from '../ui-renderers';

/**
 * Fetch current widget state from the API and update the mini widget DOM.
 */
export async function refreshWidgetState() {
  try {
    const data = await apiGetWidgetState();
    state.widgetState = data;
    updateWidgetState(data);
  } catch (_) { /* best effort — widget is non-critical */ }
}

/**
 * Start polling /api/ai/widget-state every 60 seconds.
 * No-op if already polling. Called when drawer closes.
 */
export function startWidgetPolling() {
  if (state.widgetPollTimer) return;
  void refreshWidgetState();
  state.widgetPollTimer = setInterval(refreshWidgetState, 60_000);
}

/**
 * Stop the widget polling interval.
 * Called when drawer opens — polling while visible is wasteful.
 */
export function stopWidgetPolling() {
  if (state.widgetPollTimer) {
    clearInterval(state.widgetPollTimer);
    state.widgetPollTimer = null;
  }
}
